import { Controller } from "stimulus";

export default class extends Controller {
  static targets = [
    "link",
    "tab",
    "picker",
    "term",
    "searcLink",
    "change",
    "clear"
  ];

  static values = {
    defaultTab: { type: String, default: "currentForm" },
    searchTab: { type: String, default: "searchForm" },
    newTab: { type: String, default: "newForm" },
    clientId: Number,
    ownerId: Number,
    accessionId: Number,
    searchUrl: String,
    clear: { type: String, default: "clear" },
  };


  connect() {
    this.hideAllTabs();
    let selectedLink = this.getCurrent(this.linkTargets, this.defaultTabValue)
    let selectedTab = this.getCurrent(this.tabTargets, this.defaultTabValue)
    selectedLink.classList.add("active");
    this.showTab(selectedTab);
    this.boundHandleOwnerFrame = this.handleOwnerFrame.bind(this)
    this.element.addEventListener("turbo:frame-render", this.boundHandleOwnerFrame)
    this.toogleFieldsState(selectedTab);

    this.boundKeydownHandler = this.keydownHandler.bind(this)
    document.addEventListener("keydown", this.boundKeydownHandler)
  }

  disconnect(){
    this.element.removeEventListener("turbo:frame-render", this.boundHandleOwnerFrame)
    document.removeEventListener("keydown", this.boundKeydownHandler)
  }

  select(event) {
    Turbo.setProgressBarDelay(200)
    this.prevent(event)
    // find tab with same id as clicked btn
    let selectedTab = this.getCurrent(this.tabTargets, event.currentTarget.id)
    this.hideAllTabs();
    this.linkTargets.map((x) => x.classList.remove("active")); // deactive all links
    this.showTab(selectedTab);
    event.currentTarget.classList.add("active"); // active current link
    document
      .querySelector("#" + event.currentTarget.id)
      .classList.add("active"); // if we have selected a link from the current tab
    this.toogleFieldsState(selectedTab);
  }

  generateUrl(e) {
    let term = e.currentTarget.value;
    let client_id = this.clientIdValue;
    this.searchUrlValue =
      "/owners/show_owners?term=" + term + "&client_id=" + client_id;
    this.termValue = term;
    this.searcLinkTarget.setAttribute("href", this.searchUrlValue);
    if (e.key === "Enter" || e.keyCode === 13) {
      this.searcLinkTarget.click();
    }
  }

  setPicker(e) {
    this.prevent(e)
    this.ownerIdValue = parseInt(e.currentTarget.id);

    let url =
      "/portal/submission_owner_current_tab?id=" +
      parseInt(this.accessionIdValue) +
      "&owner_id=" +
      parseInt(this.ownerIdValue);

    Turbo.visit(url, { frame: "submission_owner_current_tab" });
  }

  clear(e) {
    this.prevent(e)
    let url =
      "/portal/submission_owner_tabs?id=" +
      parseInt(this.accessionIdValue) +
      "&process=" +
      this.clearValue;
    this.ownerIdValue = "";
    Turbo.visit(url, { frame: "submission_owner_tabs" });
  }

  change(e) {
    this.prevent(e)
    this.activateTab(this.searchTabValue);
    this.disableTab(this.defaultTabValue);
  }

  showTab(tab) {
    tab.hidden = false; // show current tab
    tab.classList.add("show", "active");
  }

  hideAllTabs() {
    this.tabTargets.map((x) => (x.hidden = true)); // hide all tabs
  }

  handleOwnerFrame(e) {
    let element = e.target;
    if (element.id == "submission_owner_current_tab") {
      this.disableTab(this.searchTabValue);
      this.hiddenTab(this.newTabValue);
      this.activateTab(this.defaultTabValue);
    }

    if (element.id == "submission_owner_tabs") {
      this.disableTab(this.searchTabValue);
      this.activateTab(this.defaultTabValue);
    }
  }

  hiddenTab(tabValue) {
    let currentLink = this.getCurrent(this.linkTargets, tabValue)
    if (currentLink) {
      currentLink.hidden = true;
    }
  }

  disableTab(tabValue) {
    let currentLink = this.getCurrent(this.linkTargets, tabValue)
    let currentTab = this.getCurrent(this.tabTargets, tabValue)
    currentTab.classList.remove("active", "active");
    currentLink.classList.remove("active");
  }

  activateLink(tabValue) {
    let currentTab = this.getCurrent(this.tabTargets, tabValue)
    currentLink.classList.add("active");
  }

  activateTab(tabValue) {
    let currentLink = this.getCurrent(this.linkTargets, tabValue)
    let currentTab = this.getCurrent(this.tabTargets, tabValue)
    currentLink.classList.add("active");
    currentTab.classList.add("show", "active");
    currentTab.hidden = false;
    this.toogleFieldsState(currentTab);
  }

  getCurrent(targets, value){
    return targets.find((elem) => elem.id === value);
  }

  toogleFieldsState(selectedTab) {
    let inputs = document.querySelectorAll(".owner input");
    let selects = document.querySelectorAll(".owner select");

    if (selectedTab.id == "currentForm") {
      if (this.ownerIdValue && this.ownerIdValue > 0) {
        inputs.forEach((x) => (x.disabled = true));
        selects.forEach((x) => (x.disabled = true));
      }
    } else {
      inputs.forEach((x) => (x.disabled = false));
      selects.forEach((x) => (x.disabled = false));
    }
  }

  keydownHandler(e){
    const key = e.keyCode || e.which
    if (key == 13 && e.target.id == 'ownerSearchKey') {
      e.preventDefault();
    }
  }

  prevent(e){
    e.preventDefault();
    e.stopPropagation();
  }

}
